<template>
  <div class="contentPage">
    <main-table
      v-if="fuelFilter"
      :uniqId="uniqId"
      :settings="getSettings"
      :headers="headers"
      :listItems="fuelList"
      :filtersList="fuelFilter"
      :defaultFilter="fuelFilterDefault"
      @updateClickButton="onClickButton"
      @updateCreate="onCreate"
      @updateEdit="onEditMain"
      @updateSearch="onFilter"
      @updateRefreshFilters="onFilter"
      @updateChangeSort="onFilter"
      @updateExport="onExport"
      @updateSettings="onSettingsOpen"
      @updateEvent="onEvent"
      defaultSortBy="id"
      textCreate="Create fuel bill"
      flag="fuel"
      pageTitle="Fuel"
      isSettings
      isExport
      is-upload
    >
    </main-table>
    <add-fuel
      v-if="isFuel"
      :currentId="currentId"
      :getPermissionAction="getPermissionAction"
      :permissions="permissions"
      @updateClose="onAddFuel(false)"
      @updateFilterList="onFilterList"
    ></add-fuel>
    <remove-block
      v-if="isRemove"
      @updateRemoveItem="onRemoveItem"
      @updateRemoveClose="onRemoveClose"
    ></remove-block>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('fuel')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
    <upload-component
      v-if="isUploadComponent"
      :keys-request="{ get: 'onFuelImport', set: 'onFuelImportSave' }"
      key-header="updateFuelHeader"
      keyTable="fuel"
      @updateClose="onCloseUploadComponent"
    ></upload-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// async components
const AddFuel = () => import("@/components/Accounting/Fuel/AddFuel");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const UploadComponent = () => import("@/shared/UploadComponent/UploadComponent");
// helper
import getUniqId from "@/helper/getUniqId";
import { PERMISSIONS } from "@/constants/constants";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";

export default {
	name: "Fuel",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		AddFuel,
		RemoveBlock,
		UploadComponent,
	},
	computed: {
		...mapGetters([
			"fuelFilter",
			"fuelList",
			"permissions",
			"fuelFilterDefault",
		]),
		getPermissionAction() {
			if (
				(this.permissions[PERMISSIONS.CREATE] && !this.currentId) ||
        this.permissions[PERMISSIONS.EDIT]
			)
				return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
	},
	data: () => ({
		isRefresh: null,
		isFilterList: null,
		isFuel: false,
		currentId: null,
		isCommentsPopup: false,
		isUploadComponent: false,
		uniqId: null,
		tab: 1,
	}),
	methods: {
		...mapActions([
			"onExportLink",
			"onFuel",
			"onRemoveFuel",
			"onClearFuelFilter",
			"onFuelFilter",
			"onFuelCreate",
		]),
		onTab(value) {
			this.tab = value;
		},
		onEvent({ flag }) {
			if (flag === "upload") this.isUploadComponent = true;
		},
		onCloseUploadComponent() {
			this.isUploadComponent = false;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'fuel' });
		},
		async onFilter(info) {
			this.filterModList = info.filterModList;
			await this.onFuelFilter(info.filterModList);
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}

			if (key === "edit") {
				if (
					this.permissions[PERMISSIONS.EDIT] ||
          this.permissions[PERMISSIONS.VIEW]
				) {
					this.currentId = item.id;
					this.isFuel = true;
				}
			}
		},
		async onCreate() {
			this.currentId = null;
			this.isFuel = true;
		},
		onEditMain({ line }) {
			if (
				this.permissions[PERMISSIONS.EDIT] ||
        this.permissions[PERMISSIONS.VIEW]
			) {
				this.currentId = line.id;
				this.isFuel = true;
			}
		},
		refreshFilters() {
			this.isRefresh = getUniqId();
		},
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onAddFuel(value) {
			this.currentId = null;
			this.isFuel = value;
		},
		onEdit(id) {
			if (
				this.permissions[PERMISSIONS.EDIT] ||
        this.permissions[PERMISSIONS.VIEW]
			) {
				this.currentId = id;
				this.isFuel = true;
			}
		},
		async onRemoveItem() {
			await this.onRemoveFuel(this.removeId);
			this.isRemove = false;
		},
	},
	async mounted() {
		await this.onFuel();
	},
	destroyed() {
		this.onClearFuelFilter();
	},
};
</script>

<style scoped lang="scss">
@import "fuel";
</style>
